'use client'

import { useState } from 'react'
import { useScrollAnimation } from '@/hooks/use-scroll-animation'
import { useI18n } from '@/components/i18n-provider'

const APPLE_EASE = 'ease-[cubic-bezier(0.28,0.11,0.32,1)]'

export function PainPointsSection() {
  const { dict, t } = useI18n()
  const [openItem, setOpenItem] = useState<number | null>(0)
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation()
  const { elementRef: listRef, isVisible: listVisible } = useScrollAnimation({ threshold: 0.05 })

  const painPoints: { q: string; a: string }[] = dict?.pain?.faqs ?? []

  return (
    <section className="bg-[#f5f5f7] py-24 sm:py-28 dark:bg-[#161617]">
      <div className="container">
        <div
          ref={titleRef}
          className={`mx-auto mb-14 max-w-2xl text-center transition-all duration-700 ${APPLE_EASE} ${
            titleVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'
          }`}
        >
          <h2 className="text-balance text-3xl font-semibold tracking-[-0.02em] text-foreground sm:text-5xl">
            {t('pain.title')}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
            {t('pain.subtitle')}
          </p>
        </div>

        <div
          ref={listRef}
          className={`mx-auto max-w-3xl rounded-[28px] bg-background px-7 shadow-[0_1px_2px_rgba(0,0,0,0.04)] transition-all duration-700 sm:px-10 dark:bg-white/[0.04] dark:shadow-none ${APPLE_EASE} ${
            listVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
          }`}
        >
          {painPoints.map((item, index) => {
            const isOpen = openItem === index
            return (
              <div key={index} className={index > 0 ? 'border-t border-border/60' : ''}>
                <button
                  className="flex w-full items-center gap-6 py-6 text-left"
                  onClick={() => setOpenItem(isOpen ? null : index)}
                  aria-expanded={isOpen}
                >
                  <span className="flex-1 text-lg font-medium tracking-tight text-foreground">
                    {item.q}
                  </span>
                  <span
                    className={`relative h-3.5 w-3.5 shrink-0 text-muted-foreground transition-transform duration-300 ${APPLE_EASE} ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                    aria-hidden
                  >
                    <span className="absolute left-1/2 top-1/2 h-px w-3.5 -translate-x-1/2 -translate-y-1/2 bg-current" />
                    <span className="absolute left-1/2 top-1/2 h-3.5 w-px -translate-x-1/2 -translate-y-1/2 bg-current" />
                  </span>
                </button>
                <div
                  className={`grid overflow-hidden transition-all duration-300 ${APPLE_EASE} ${
                    isOpen ? 'grid-rows-[1fr] pb-6 opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <p className="overflow-hidden leading-relaxed text-muted-foreground">{item.a}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
